import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '~/components';
import { useSendInvitationCardholder, useSoftDeclineGoFixApplication } from '~/controllers/wizard';
import { sendInvitationCardholder } from '~/api/wizard';

const UpdateApplicationButton: any = ({ title, rejectedCardholderEmails }: any) => {
  // const { title }: any = props;
  const { t } = useTranslation('stageResult');
  const goFixApplicationMutation = useSoftDeclineGoFixApplication();
  const sendInvitationCardholder = useSendInvitationCardholder();
  return (
    <Button
      style={{ whiteSpace: 'normal', height: 'auto', width: !rejectedCardholderEmails?.length ? 200 : undefined }}
      id="updateApplication_updateButton"
      type="primary"
      onClick={() => {
        goFixApplicationMutation.mutate();
        if (rejectedCardholderEmails?.length) {
          setTimeout(() => {
            sendInvitationCardholder.mutate(rejectedCardholderEmails);
          }, 3000);
        }
      }}
      loading={goFixApplicationMutation.isLoading}
      block
    >
      {title || t('Update Application')}
    </Button>
  );
};

export default UpdateApplicationButton;
